import React from 'react';
import { useIsTouchableDevice } from '@philips-internal/oswald-ui-components';
import { ReactComponent as ThreeDotSvg } from '../../../../resources/assets/DLS_MoreVertical.svg';
function ThreeDotIcon(props) {
    const isTouchableDevice = useIsTouchableDevice();
    if (!isTouchableDevice) {
        return null;
    }
    return React.createElement(ThreeDotSvg, { ...props });
}
export { ThreeDotIcon, };
//# sourceMappingURL=three-dot-icon.js.map